import React from 'react';
import StepGraph from './Graph/StepGraph';

import {
    Card,
    CardBody,
    Col,
    Row
} from "reactstrap";

import { OverViewData } from '../../CommonData/Data/index';



const OverViewStep = ({ userlvl }) => {
    return (
        <React.Fragment>
            <Col xl={8}>
                <Card>
                    <CardBody>
                        <div className="d-flex align-items-center">
                            <div className="flex-grow-1">
                                <h5 className="card-title">Aperçus des étapes</h5>
                            </div>


                        </div>
                        <div>
                            <StepGraph />
                        </div>
                    </CardBody>

                    {userlvl === 4 && (
                        <CardBody className="border-top">
                            <div className="text-muted text-center">

                            </div>
                        </CardBody>
                    )}

                    {userlvl === 3 && (
                        <CardBody className="border-top">
                            <div className="text-muted text-center">
                                <Row>
                                    {OverViewData.map((item, key) => (<Col md={4} key={key} className="border-end">
                                        <div>
                                            <p className="mb-2"><i className={"mdi mdi-circle font-size-12 me-1 text-" + item.color}></i> {item.title}</p>
                                            <h5 className="font-size-16 mb-0"> {item.count} <span className="text-success font-size-12"><i className="mdi mdi-menu-up font-size-14 me-1"></i>{item.percentage} %</span></h5>
                                        </div>
                                    </Col>))}
                                </Row>
                            </div>
                        </CardBody>
                    )}


                </Card>
            </Col>
        </React.Fragment>
    );
};

export default OverViewStep;